@if (bannerVisible) {
  <div class="fixed-bottom w-100 cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-describedby="cookie-banner-text">
    <div class="cookie-content">
      <h2 id="cookie-banner-title" class="veryLargeText">{{ 'cookies.title' | t }}</h2>
      <p id="cookie-banner-text">
        {{ 'cookies.banner' | t }}
        <a class="verySmallText" routerLink="/cookies">{{ 'cookies.policyLink' | t }}</a>
      </p>
      <div class="cookie-actions">
        <button mat-stroked-button type="button" (click)="deny()" class="cookie-button" id="btnDeny">
          {{ 'cookies.rejectAll' | t }}
        </button>
        <button mat-stroked-button type="button" (click)="openDialog()" class="cookie-button" id="btnCustomize">
          {{ 'cookies.customize' | t }}
        </button>
        <button mat-stroked-button type="button" (click)="accept()" class="cookie-button" id="btnAccept">
          {{ 'cookies.acceptAll' | t }}
        </button>
      </div>
    </div>
  </div>
}
